<template>
  <div v-if="setup">
    <h3 class="ui dividing header">{{ $t("personal information") }}</h3>
    <div class="ui five mini statistics">
      <div class="blue statistic">
        <div class="value">
          <i class="id badge icon"></i>
          {{ setup.student_id_card }}
        </div>
        <div class="label">{{ $t("student id card") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="id card icon"></i>
          {{ setup.dpi }}
        </div>
        <div class="label">{{ $t("dpi") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="birthday cake icon"></i>
          {{
            setup.birthdate
              | formatDate(
                enterprise_setup ? enterprise_setup.simple_date_format : "",
              )
          }}
        </div>
        <div class="label">{{ $t("birthdate") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i
            class="icon"
            v-bind:class="{
              mars: setup.gender == 'm',
              venus: setup.gender == 'f',
            }"
          ></i>
          {{ decode_gender(setup.gender) }}
        </div>
        <div class="label">{{ $t("gender") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i
            class="icon"
            v-bind:class="{
              restroom: setup.civil_status == 'm',
              male: setup.civil_status == 's',
            }"
          ></i>
          {{ decode_civil_status(setup.civil_status) }}
        </div>
        <div class="label">{{ $t("civil status") }}</div>
      </div>
    </div>

    <h3 class="ui dividing header">{{ $t("contact vias") }}</h3>
    <div class="ui three mini statistics">
      <div class="blue statistic">
        <div class="value">
          <i class="mobile icon"></i>
          {{ setup.cellphone }}
        </div>
        <div class="label">{{ $t("cellphone") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="phone icon"></i>
          {{ setup.residential_phone }}
        </div>
        <div class="label">{{ $t("residential phone") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="at icon"></i>
          {{ setup.email }}
        </div>
        <div class="label">{{ $t("email") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="home icon"></i>
          {{ setup.residential_address }}
        </div>
        <div class="label">{{ $t("residential address") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="industry icon"></i>
          {{ setup.work_address }}
        </div>
        <div class="label">{{ $t("work address") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="industry icon"></i>
          {{ setup.workplace }}
        </div>
        <div class="label">{{ $t("workplace") }}</div>
      </div>
    </div>

    <h4 class="ui dividing header">{{ $t("academic background") }}</h4>
    <div class="ui four mini statistics">
      <div class="statistic">
        <div class="value">
          <i class="university icon"></i>
          {{ setup.stablishment_name }}
        </div>
        <div class="label">{{ $t("stablishment name") }}</div>
      </div>
      <div class="statistic">
        <div class="value">
          <i class="user graduate icon"></i>
          {{ setup.degree_title }}
        </div>
        <div class="label">{{ $t("degree title") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { enterprise_setup } from "@/utils";
import filters from "@/filters";

// @ is an alias to /src
export default {
  name: "StudentViewGeneralInfo",
  components: {},
  props: { setup: Object },
  filters: filters,
  data() {
    return {};
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    decode_gender(value) {
      if (value == "m") return this.$t("male");
      else if (value == "f") return this.$t("female");
      else if (value == "u") return this.$t("undefined");
    },
    decode_civil_status(value) {
      if (value == "m") return this.$t("married");
      else if (value == "s") return this.$t("single");
    },
    succedded(data) {
      console.log(data);
    },
    destroy() {
      this.student_modals = [];
    },
  },
  mounted() {},
  watch: {
    filter() {},
  },
};
</script>

<style>
.statistics .statistic {
  margin: 20px auto !important;
}
</style>
